// import 'lib-flexible';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import store from '@/store';
import App from './pages/App';
import './index.less';
document.documentElement.style.fontSize = 39 + "px";

ReactDOM.render((
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>
), document.getElementById('root'));